import { locations } from "./locations";
import { news } from "./news";
import { pcnnews } from "./pcnnews";
import { alerts } from "./alerts";
import { infopages } from "./infopages";
import { practiceteam } from "./practiceteam";
import { nonnhsfees } from "./nonnhsfees";
import { footer } from "./footer";
import { quicklinks } from "./quicklinks";
import { openinghours } from "./openinghours";
import { general } from "./general";
import { analyticsresult } from "./analyticsresult";
import { onlineservices } from "./onlineservices";
import { healthiertogether } from "./healthiertogether";
import { jobvacancies } from "./jobvacancies";
import { globalupdate } from "./globalupdate";
import { patientgroup } from "./patientgroup";
import { bannersicb } from "./bannersicb";
import { banners } from "./banners";
import { pcnoverview } from "./pcnoverview";
import { whatisapcn } from "./whatisapcn";
import { pcnteam } from "./pcnteam";
import { pcnservices } from "./pcnservices";
import { extendedhours } from "./extendedhours";
import { memberpractices } from "./memberpractices";
import { partnerorganisations } from "./partnerorganisations";
import { clinicsandservices } from "./clinicsandservices";
import { selfreferrals } from "./selfreferrals";
import { pcnselfreferrals } from "./pcnselfreferrals";
import { meetingandevents } from "./meetingandevents";
import { pcnevents } from "./pcnevents";
import { meetingminutes } from "./meetingminutes";
import { videos } from "./videos";
import { faqs } from "./faqs";
import { appointments } from "./appointments";
import { contactus } from "./contactus";
import { commonailments } from "./commonailments";
import { prescriptions } from "./prescriptions";
import { cancelappointments } from "./cancelappointments";
import { bookappointments } from "./bookappointments";
import { jointhepractice } from "./jointhepractice";
import { sickfitnotes } from "./sickfitnotes";
import { recommendedapps } from "./recommendedapps";
import { cqcrating } from "./cqcrating";
import { socialmedia } from "./socialmedia";
import { pcnsocialmedia } from "./pcnsocialmedia";
import { mailsettings } from "./mailsettings";
import { pcnemailsettings } from "./pcnemailsettings";
import { pcninsights } from "./pcninsights";
import { jointhepracticeicb } from "./jointhepracticeicb";
import { prescriptionsicb } from "./prescriptionsicb";
import { sickfitnotesicb } from "./sickfitnotesicb";
import { carerinformationicb } from "./carerinformationicb";
import { patientgroupicb } from "./patientgroupicb";
import { carerinformation } from "./carerinformation";
import { practiceinfo } from "./practiceinfo";
import { bloodtestsandresults } from "./bloodtestsandresults";
import { feedback } from "./feedback";
import { staff } from "./staff";
import { patchs } from "./patchs";
import { rapidhealth } from "./rapidhealth";
import { anima } from "./anima";
import { patientassist } from "./patientassist";
import { patientvoice } from "./patientvoice";
import { receptionenquiries } from "./receptionenquiries";
import { practicepolicies } from "./practicepolicies";
import { managingmycondition } from "./managingmycondition";
import { pcninfo } from "./pcninfo";
import { manageconditions } from "./managcondition";
import { aboutus } from "./aboutus";
import { healthandwellbeing } from "./healthandwellbeings";
import { landingpage } from "./landingpage";
import { communitywellbeing } from "./communitywellbeing";
import { healthcampaigns } from "./healthcampaigns";
import { onlineforms } from "./onlineforms";

const ui = {
  locations: locations,
  patientnews: news,
  pcnnews: pcnnews,
  infopages: infopages,
  alerts: alerts,
  practiceteam: practiceteam,
  nonnhsfees: nonnhsfees,
  footer: footer,
  quicklinks: quicklinks,
  openinghours: openinghours,
  general: general,
  analyticsresult: analyticsresult,
  onlineservices: onlineservices,
  healthiertogether: healthiertogether,
  jobvacancies: jobvacancies,
  globalupdate: globalupdate,
  patientgroup: patientgroup,
  banners: banners,
  bannersicb: bannersicb,
  pcnoverview: pcnoverview,
  whatisapcn: whatisapcn,
  pcnteam: pcnteam,
  pcnservices: pcnservices,
  extendedhours: extendedhours,
  memberpractices: memberpractices,
  partnerorganisations: partnerorganisations,
  "clinics&services": clinicsandservices,
  selfreferrals: selfreferrals,
  pcnselfreferrals: pcnselfreferrals,
  "meeting&events": meetingandevents,
  pcnevents: pcnevents,
  meetingminutes: meetingminutes,
  videos: videos,
  faqs: faqs,
  appointments: appointments,
  contactus: contactus,
  commonailments: commonailments,
  prescriptions: prescriptions,
  cancelappointments: cancelappointments,
  bookappointments: bookappointments,
  jointhepractice: jointhepractice,
  "sick/fitnotes": sickfitnotes,
  "recommend.apps": recommendedapps,
  cqcrating: cqcrating,
  socialmedia: socialmedia,
  pcnsocialmedia: pcnsocialmedia,
  mailsettings: mailsettings,
  pcnmailsettings: pcnemailsettings,
  pcninsights: pcninsights,
  jointhepracticeicb: jointhepracticeicb,
  prescriptionsicb: prescriptionsicb,
  "sick/fitnotesicb": sickfitnotesicb,
  carerinformationicb: carerinformationicb,
  patientgroupicb: patientgroupicb,
  carerinformation: carerinformation,
  "practiceinfo.": practiceinfo,
  "tests&results": bloodtestsandresults,
  feedback: feedback,
  staff: staff,
  patchs: patchs,
  rapidhealth: rapidhealth,
  anima: anima,
  patientassist: patientassist,
  patientvoice: patientvoice,
  receptionenquiries: receptionenquiries,
  practicepolicies: practicepolicies,
  managingmycondition: managingmycondition,
  "pcninfo.": pcninfo,
  managecondition: manageconditions,
  aboutus: aboutus,
  "health&wellbeing": healthandwellbeing,
  landingpage: landingpage,
  communitywellbeing: communitywellbeing,
  healthcampaigns: healthcampaigns,
  onlineforms: onlineforms,
};

export { ui };
